// extracted by mini-css-extract-plugin
export default {"description":"style_description__F02it","fade-in":"style_fade-in__91msP","top":"style_top__yauxE","image":"style_image__M1+eP"};